import { render, staticRenderFns } from "./AcceptTermsForm.vue?vue&type=template&id=7c19fb22&"
import script from "./AcceptTermsForm.vue?vue&type=script&lang=js&"
export * from "./AcceptTermsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports